export default "__VITE_ASSET__wYDj0of1__"